@if (!profileStore?.state || busy) {
  <sharry-loading [fullscreen]="true"></sharry-loading>
}
<ng-container
  [ngTemplateOutlet]="pageTemplate"
  [ngTemplateOutletContext]="{ user: profileStore?.state$ | async }"></ng-container>
<ng-template
  #pageTemplate
  let-user="user"
  [typeToken]="typeToken">
  @if (profileStore.state || !busy) {
    <div class="profile">
      <sharry-header-content
        id="profile-header-content"
        class="profile__header"
        [class.profile__header--intersecting]="headerIntersecting"
        [showShareButton]="user.isVisible"
        [showLikeButton]="user.isVisible"
        [content]="$any(user)"></sharry-header-content>
      <section
        class="profile__hero-container"
        [class.profile__hero-container--cover]="!!user?.coverPicture?.image">
        <div class="profile__hero-container__user">
          <div [avatar]="{ user: user, size: 'big', imgSize: '120px' }"></div>
          <div
            *appShellNoRender
            class="profile__hero-container__user__buttons">
            @if (!user?.isMe && (!user?.anonymised || !user?.blockedMe || !onFollowBusy) && user?.myFollow) {
              <button
                class="sharry-medium rounded"
                mat-stroked-button
                [color]="'primary'"
                [disabled]="onFollowBusy"
                (click)="!onFollowBusy && onFollow(); $event.stopPropagation(); $event.preventDefault()">
                <!-- ICONA USER -->
                <sharry-icon
                  registryName="user-plus"
                  svgClass="svg-icon"></sharry-icon>
                {{ 'profile.unfollow' | i18next }}
              </button>
            }
            @if (!user?.isMe && (!user?.anonymised || !user?.blockedMe || !onFollowBusy) && !user?.myFollow) {
              <button
                class="sharry-medium rounded profile__hero-container__user__buttons--border"
                mat-flat-button
                [color]="'primary'"
                [disabled]="onFollowBusy"
                (click)="!onFollowBusy && onFollow(); $event.stopPropagation(); $event.preventDefault()">
                <!-- ICONA USER -->
                <sharry-icon
                  registryName="user-plus"
                  svgClass="svg-icon"></sharry-icon>
                {{ 'profile.follow' | i18next }}
              </button>
            }
            @if (!user?.isMe && !user?.anonymised && !user?.blockedMe) {
              <button
                color="secondary"
                class="sharry-medium rounded"
                mat-stroked-button
                (click)="onWriteClick()">
                <sharry-icon
                  registryName="chat-text"
                  svgClass="svg-icon"></sharry-icon>
                {{ 'profile.enquiry-pro' | i18next }}
              </button>
            }
          </div>
        </div>
        @if (!!user?.coverPicture?.image?.fullsize) {
          <picture
            data-image-loading
            (click)="onShowGalleryChange()">
            <source
              media="(max-width: 480px)"
              [srcset]="user?.coverPicture?.image?.vw480" />
            <source
              media="(max-width: 767px)"
              [srcset]="user?.coverPicture?.image?.vw768" />
            <source
              media="(max-width: 1023px)"
              [srcset]="user?.coverPicture?.image?.vw1024" />
            <img
              fetchpriority="high"
              loading="eager"
              alt="cover"
              [src]="user?.coverPicture?.image?.fullsize" />
          </picture>
        }
      </section>
      <div class="profile__scrollable">
        <div class="profile__grid">
          <div class="profile__grid__body">
            <div class="title-box">
              <div class="title-box--cherry">
                <sharry-cherry-box
                  id="cherry-box-profile"
                  [__typename]="'User'"
                  [username]="user | userName"
                  [totalCherries]="user?.totalCherries || 0"></sharry-cherry-box>
              </div>
              <sharry-entity-title [content]="$any(user)"></sharry-entity-title>
              <div class="profile__grid__category-container">
                <h2 class="heading__title">{{ user | userName }}</h2>
                @if (user?.originalWhoIAm) {
                  <h3 class="heading__subtitle">
                    {{ !!seeTranslated ? user?.whoIAm : user?.originalWhoIAm }}
                  </h3>
                }
                <ng-container
                  [ngTemplateOutlet]="qualification"
                  [ngTemplateOutletContext]="{ user: user }"></ng-container>
                @if (user?.workAddress) {
                  <div class="heading__location">
                    <a
                      class="sharry-simple"
                      [routerLink]="['search-results' | routeTranslate, 'map']"
                      [queryParams]="{
                        value: user?.workAddress,
                        latitude: user?.latitude,
                        longitude: user?.longitude,
                        distance: 10,
                        withUsers: true,
                        prefix: 'location',
                        mode: 'map',
                        zoom: 15,
                      }">
                      <sharry-icon
                        name="map-trifold"
                        type="phosphor"
                        svgClass="svg-icon"></sharry-icon>
                      {{ user?.workAddress }}
                    </a>
                  </div>
                }
                @if (user?.categories?.length) {
                  <ng-container
                    [ngTemplateOutlet]="categories"
                    [ngTemplateOutletContext]="{ user: user }"></ng-container>
                }
              </div>
            </div>
            @if (user?.land?.title) {
              <div class="profile__land-info">
                <a [routerLink]="user?.land | slug">
                  <img
                    alt="icon snapshot"
                    src="https://media.sharry.land/app/meraviglie/ic-land.webp"
                    height="50"
                    width="50" />
                  <span
                    >{{ 'content.land-info' | i18next | uppercase }}&nbsp;<strong>{{
                      user?.land?.title | uppercase
                    }}</strong>
                    <sharry-icon
                      name="arrow-right"
                      svgClass="svg-icon"></sharry-icon
                  ></span>
                </a>
              </div>
            }
            <div class="profile__grid__description">
              @if (!!user?.originalWhatICanDo) {
                <h4>
                  {{ 'profile.stuff-i-can-do' | i18next }}
                  @if (translateService.language !== user?.originalLanguage) {
                    <button
                      class="sharry-simple profile__grid__description--button-translate"
                      (click)="onTranslate(user?.slug, user?.id)">
                      <sharry-icon
                        name="translate"
                        svgClass="svg-icon"></sharry-icon>
                      {{
                        (!!seeTranslated
                          ? 'profile.button-translate.see-original'
                          : 'profile.button-translate.translate'
                        ) | i18next
                      }}
                    </button>
                  }
                </h4>
              }
              <section>
                <section>
                  <p [innerHTML]="!!seeTranslated ? user?.whatICanDo : user?.originalWhatICanDo"></p>
                  <div class="useful-info">
                    <h4>
                      <!-- <button mat-icon-button
                                class="sharry-small"
                                color="secondary"
                                (click)="onShowMoreInfo()">
                          <sharry-icon name="lightbulb-filament-duotone"
                                       type="custom"
                                       svgClass="svg-icon"></sharry-icon>
                        </button> -->
                      {{ 'profile.personal-info-ut' | i18next }}
                    </h4>
                    <button
                      class="semibold bigger sharry-simple"
                      (click)="onShowMoreInfo()">
                      {{ (usefulCollapsed ? 'profile.show' : 'profile.hide') | i18next }}
                      <sharry-icon
                        svgClass="svg-icon caret"
                        [name]="usefulCollapsed ? 'caret-down' : 'caret-up'"></sharry-icon>
                    </button>
                    @if (!usefulCollapsed) {
                      <ng-container
                        [ngTemplateOutlet]="proDetails"
                        [ngTemplateOutletContext]="{ user: user }"></ng-container>
                      <ng-container
                        [ngTemplateOutlet]="address"
                        [ngTemplateOutletContext]="{ user: user }"></ng-container>
                      <ng-container
                        [ngTemplateOutlet]="contacts"
                        [ngTemplateOutletContext]="{ user: user }"></ng-container>
                      <ng-container
                        [ngTemplateOutlet]="usefulInformations"
                        [ngTemplateOutletContext]="{ user: user }"></ng-container>
                    }
                  </div>
                  <ng-container
                    [ngTemplateOutlet]="photos"
                    [ngTemplateOutletContext]="{ user: user }"></ng-container>
                </section>
              </section>
            </div>
            <ng-container>
              @if (
                (user?.posterImage?.video && (posterImageClicked || !user?.posterImage?.image)) ||
                (user?.posterImage?.image && !posterImageClicked)
              ) {
                <h4>
                  {{ user?.posterImage?.title }}
                </h4>
              }
              @if (user?.posterImage?.video && (posterImageClicked || !user?.posterImage?.image)) {
                <div
                  class="profile__grid__description__embed"
                  [innerHTML]="user?.posterImage.video | safe: 'html'"></div>
              }
              @if (user?.posterImage?.image && !posterImageClicked) {
                <div class="profile__grid__description__embed">
                  <img
                    alt="poster"
                    class="cursor-pointer"
                    src="{{ user?.posterImage.image }}"
                    (click)="posterImageClicked = true" />
                  <img
                    class="profile__grid__description__embed-overlay"
                    alt="video"
                    src="https://media.sharry.land/app/images/ic-play_2.svg" />
                </div>
              }
            </ng-container>

            @if (user?.posterImage?.label) {
              <p class="profile__grid__description__embed-label">
                {{ user?.posterImage?.label }}
              </p>
            }
          </div>

          <div class="profile__grid__boxes">
            <sharry-people-likes
              class="is-not-mobile"
              [showShareButton]="user.isVisible"
              [showLikeButton]="user.isVisible"
              [content]="$any(user)"></sharry-people-likes>
            <!--Box chi mi segue-->
            @if (!!user?.followers?.length) {
              <div class="profile__grid__boxes--box">
                <h4>{{ 'profile.followers' | i18next }}</h4>
                <p>
                  <span
                    [innerHTML]="
                      user?.followers?.length
                        | i18nPlural: itemPluralMapping['followers']
                        | i18next: { people: user?.followersCount }
                    "></span>
                </p>
                <div class="followers">
                  <div class="cursor-pointer">
                    <sharry-people-avatar-list
                      [users]="user?.followers"
                      [count]="user?.followersCount"
                      [maxLength]="6"
                      (peopleClicked)="
                        !followerBusy && onFollowersClick(); $event.stopPropagation(); $event.preventDefault()
                      "></sharry-people-avatar-list>
                  </div>
                </div>
              </div>
            }
            <!--Box chi seguo-->
            @if (!!user?.followingsUser?.length) {
              <div class="profile__grid__boxes--box">
                <h4>{{ 'profile.following' | i18next }}</h4>
                <p>
                  <span
                    [innerHTML]="
                      user?.followingsUser?.length
                        | i18nPlural: itemPluralMapping['followings']
                        | i18next: { people: user?.followingsCount }
                    "></span>
                </p>
                @if (!!user?.followings?.length) {
                  <div class="followers">
                    <div class="cursor-pointer">
                      <sharry-people-avatar-list
                        [users]="user?.followingsUser"
                        [count]="user?.followingsCount"
                        [maxLength]="6"
                        (peopleClicked)="
                          !userFollowingsBusy && onFollowingsClick(); $event.stopPropagation(); $event.preventDefault()
                        "></sharry-people-avatar-list>
                    </div>
                  </div>
                }
              </div>
            }
            <!--Box cosa mi piace-->
            @if (user?.contentClappings.length) {
              <div class="profile__grid__boxes--box">
                <h4>{{ 'profile.favourite-contents' | i18next }}</h4>
                @for (entity of user?.contentClappings.slice(0, 2); track entity.id; let index = $index) {
                  <a
                    class="post"
                    [routerLink]="entity.content | slug">
                    <img
                      alt="cover"
                      [src]="$any(entity?.content)?.coverPicture?.bestVersion?.url" />
                    <div class="post--short">
                      <p
                        class="content"
                        [innerHTML]="entity?.content | colorize: 'short'"></p>
                      <p
                        sharryEllipsisTooltip="1"
                        class="semibold">
                        {{ $any(entity?.content)?.title }}
                      </p>
                    </div>
                  </a>
                }
                @if (contentClappingsBusy) {
                  <sharry-loading></sharry-loading>
                }
                @if (user?.clappingsCount > 2 && !contentClappingsBusy) {
                  <a
                    class="semibold"
                    (click)="onFavouritesClick()"
                    >{{ 'profile.posts.show-more' | i18next }}
                    <sharry-icon
                      registryName="caret-right"
                      class="svg-icon caret"></sharry-icon>
                  </a>
                }
              </div>
            }
            <!-- Box rete-->
            <ng-container
              [ngTemplateOutlet]="networks"
              [ngTemplateOutletContext]="{ user: user }"></ng-container>
            @if (!user?.isMe) {
              <sharry-report [data]="{ reportedEntityId: user?.id, reportedEntityType: reportableEntityEnum.User }">
              </sharry-report>
            }
          </div>
        </div>

        @if (
          user?.profileOwnedSharryExperiences?.length ||
          user?.profileOwnedSharryItems?.length ||
          user?.profileOwnedSharryRentals?.length ||
          user?.profileOwnedSharryTours?.length ||
          user?.profilePaladinWonders?.length ||
          user?.profileCollaboratedWonders?.length ||
          user?.profileContributesCount ||
          user?.profilePosts.length ||
          user?.networkOwnerships?.length
        ) {
          <section class="profile__activity">
            @if (user?.networkOwnerships?.length > 0) {
              <div class="profile__network">
                <div class="profile__network__details">
                  <h2 class="bold">{{ 'profile.our-network' | i18next }}</h2>
                  <div>
                    <img
                      alt="network"
                      [src]="user?.networkOwnerships[0].image?.url" />
                    <div>
                      <p class="bigger medium">{{ user?.networkOwnerships[0].name }}</p>
                      <p class="bigger">{{ user?.networkOwnerships[0].longDescription }}</p>
                      <button
                        mat-flat-button
                        class="sharry-small"
                        color="primary"
                        routerLink="{{ 'network' | routeTranslate: true }}">
                        <sharry-icon
                          name="map-trifold"
                          type="phosphor"
                          class="svg-icon"></sharry-icon>
                        <span class="text">{{ 'profile.map' | i18next }}</span>
                      </button>
                    </div>
                  </div>
                </div>
                @if (!user?.networkSubscribers && networkBusy) {
                  <sharry-loading></sharry-loading>
                }
                @if (user?.networkSubscribers?.length) {
                  <div class="profile__activity__contents">
                    <sharry-card-carousel
                      [usePagination]="true"
                      [contents]="user?.networkSubscribers"
                      [carouselTitle]="'profile.subscribers'"
                      [grid]="{ xs: 1, sm: 2, md: 3, lg: 4, xl: 4 }"></sharry-card-carousel>
                  </div>
                }
              </div>
            }
            @if (
              user?.profileOwnedSharryExperiences?.length ||
              user?.profileOwnedSharryItems?.length ||
              user?.profileOwnedSharryRentals?.length ||
              user?.profileOwnedSharryTours?.length ||
              user?.profilePaladinWonders?.length ||
              user?.profileCollaboratedWonders?.length ||
              user?.profileOrganizedEvents?.length ||
              user?.profilePosts?.length
            ) {
              <div>
                <h2 class="bold">{{ 'profile.my-activity' | i18next }}</h2>
                @if (sharryBusy) {
                  <sharry-loading></sharry-loading>
                }
                @if (
                  (user?.profileOwnedSharryExperiences?.length ||
                    user?.profileOwnedSharryItems?.length ||
                    user?.profileOwnedSharryRentals?.length ||
                    user?.profileOwnedSharryTours?.length) &&
                  !sharryBusy
                ) {
                  <div class="profile__activity__contents-container">
                    @if (user?.profileOwnedSharryTours?.length) {
                      <sharry-card-carousel
                        [usePagination]="true"
                        [contents]="user?.profileOwnedSharryTours"
                        [carouselTitle]="'profile.organizer-tours'"
                        [grid]="{ xs: 1, sm: 2, md: 3, lg: 4, xl: 4 }"></sharry-card-carousel>
                    }
                    @if (user?.profileOwnedSharryExperiences?.length) {
                      <sharry-card-carousel
                        [usePagination]="true"
                        [contents]="user?.profileOwnedSharryExperiences"
                        [carouselTitle]="'profile.organizer-experiences'"
                        [grid]="{ xs: 1, sm: 2, md: 3, lg: 4, xl: 4 }"></sharry-card-carousel>
                    }
                    @if (user?.profileOwnedSharryItems?.length) {
                      <sharry-card-carousel
                        [usePagination]="true"
                        [contents]="user?.profileOwnedSharryItems"
                        [carouselTitle]="'profile.organizer-items'"
                        [grid]="{ xs: 1, sm: 2, md: 3, lg: 4, xl: 4 }"></sharry-card-carousel>
                    }
                    @if (user?.profileOwnedSharryRentals?.length) {
                      <sharry-card-carousel
                        [usePagination]="true"
                        [contents]="user?.profileOwnedSharryRentals"
                        [carouselTitle]="'profile.organizer-rentals'"
                        [grid]="{ xs: 1, sm: 2, md: 3, lg: 4, xl: 4 }"></sharry-card-carousel>
                    }
                  </div>
                }
                @if (!user?.profilePaladinWonders && paladinWonderBusy && !networkBusy) {
                  <sharry-loading></sharry-loading>
                }
                @if (user?.profilePaladinWonders?.length && !networkBusy) {
                  <div class="profile__activity__contents">
                    <sharry-card-carousel
                      [usePagination]="true"
                      [contents]="user?.profilePaladinWonders"
                      [carouselTitle]="'profile.paladin'"
                      [grid]="{ xs: 1, sm: 2, md: 3, lg: 4, xl: 4 }"></sharry-card-carousel>
                  </div>
                }
                @if (
                  !user?.profileCollaboratedWonders && collaboratedWonderBusy && !networkBusy && !paladinWonderBusy
                ) {
                  <sharry-loading></sharry-loading>
                }
                @if (user?.profileCollaboratedWonders?.length && !networkBusy && !paladinWonderBusy) {
                  <div class="profile__activity__contents">
                    <sharry-card-carousel
                      [usePagination]="true"
                      [contents]="user?.profileCollaboratedWonders"
                      [carouselTitle]="'profile.author'"
                      [grid]="{ xs: 1, sm: 2, md: 3, lg: 4, xl: 4 }"></sharry-card-carousel>
                  </div>
                }
                @if (
                  !user?.profileOrganizedEvents &&
                  eventBusy &&
                  !networkBusy &&
                  !paladinWonderBusy &&
                  !collaboratedWonderBusy
                ) {
                  <sharry-loading></sharry-loading>
                }
                @if (
                  user?.profileOrganizedEvents?.length && !networkBusy && !paladinWonderBusy && !collaboratedWonderBusy
                ) {
                  <div class="profile__activity__contents">
                    <sharry-card-carousel
                      [usePagination]="true"
                      [contents]="user?.profileOrganizedEvents"
                      [carouselTitle]="'profile.event-organizer'"
                      [grid]="{ xs: 1, sm: 2, md: 3, lg: 4, xl: 4 }"></sharry-card-carousel>
                  </div>
                }
                @if (postsBusy && !eventBusy && !networkBusy && !paladinWonderBusy && !collaboratedWonderBusy) {
                  <sharry-loading></sharry-loading>
                }
                @if (
                  user?.profilePosts?.length &&
                  !networkBusy &&
                  !paladinWonderBusy &&
                  !collaboratedWonderBusy &&
                  !postsBusy
                ) {
                  <div class="profile__activity__contents">
                    <sharry-card-carousel
                      [usePagination]="true"
                      [contents]="user?.profilePosts"
                      [mode]="'template'"
                      [itemTemplate]="postTemplate"
                      [carouselTitle]="'profile.posts.title'"
                      [grid]="{ xs: 1, sm: 1, md: 3, lg: 4, xl: 4 }">
                      <ng-template
                        #postTemplate
                        let-item>
                        <sharry-post-card [post]="item"></sharry-post-card>
                      </ng-template>
                    </sharry-card-carousel>
                  </div>
                }
              </div>
            }
          </section>
        }
        @if (
          !user?.networkOwnerships?.length &&
          !(
            user?.profileOwnedSharryExperiences?.length ||
            user?.profileOwnedSharryItems?.length ||
            user?.profileOwnedSharryRentals?.length ||
            user?.profileOwnedSharryTours?.length ||
            user?.profilePaladinWonders?.length ||
            user?.profileCollaboratedWonders?.length ||
            user?.profileContributesCount ||
            user?.profilePosts?.length
          )
        ) {
          <br />
        }
      </div>
    </div>
  }
</ng-template>

<ng-template
  #qualification
  let-user="user">
  @if (user?.ambassador || user?.isPaladin || user?.friendlyMunicipality) {
    <p class="bold qualification">
      @if (!!user?.ambassador) {
        <span>
          <img
            alt="ciliegia"
            [src]="'https://media.sharry.land/app/images/ic-ambassador-no-circle.svg'" />{{
            'profile.ambassador' | i18next
          }}</span
        >
      }
      @if (!!user?.isPaladin) {
        <span>
          @if (!!user?.ambassador) {
            <span class="dot">&#8226;</span>
          }
          <img
            alt="paladino"
            [src]="'https://media.sharry.land/app/images/ic-profilo-paladino.svg'" />{{
            'profile.is-paladin' | i18next
          }}</span
        >
      }
      @if (user?.friendlyMunicipality) {
        <span>
          @if (!!user?.ambassador || !!user?.isPaladin) {
            <span class="dot">&#8226;</span>
          }
          <img
            alt="ciliegia"
            [src]="'https://media.sharry.land/app/images/ic-comuni.svg'" />{{
            'profile.friendly-municipality' | i18next
          }}</span
        >
      }
    </p>
  }
</ng-template>

<ng-template
  #categories
  let-user="user"
  [typeToken]="typeToken">
  <div class="heading__figure-container">
    @for (category of user?.categories || [] | slice: 0 : 3; track category.id; let index = $index) {
      <a
        [ngClass]="{ 'is-not-mobile': index === 2 }"
        [routerLink]="['category' | routeTranslate, category.normalizedName]">
        @if (!!category?.name) {
          <figure
            class="heading__figure"
            (click)="onCategorySearch(category.id)">
            <img
              [src]="category?.icon?.url"
              [alt]="category?.name" />
            <figcaption>{{ category?.name }}</figcaption>
          </figure>
        }
      </a>
    }
  </div>
</ng-template>

<ng-template
  #photos
  let-user="user"
  [typeToken]="typeToken">
  @if (user?.pictures?.length > 1) {
    <div class="info-section">
      <div class="info-section__photos">
        @for (picture of user?.pictures; track picture.id; let i = $index) {
          <div
            [class.hidden]="i > (limit$ | async)"
            [style.background-image]="'url(' + picture.image?.url + ')'"
            (click)="onShowGalleryChange(i)">
            @if (i === (limit$ | async) && user?.pictures?.length > (limit$ | async) + 1) {
              <div class="info-section__photos__number-overlay">+ {{ user?.pictures?.length - maxPictures }}</div>
            }
          </div>
        }
      </div>
    </div>
  }
</ng-template>

<ng-template
  #networks
  let-user="user"
  [typeToken]="typeToken">
  @if (user?.networks?.length) {
    <div class="profile__grid__boxes--box">
      <h4>{{ 'profile.networks' | i18next }}</h4>
      @for (network of user?.networks; track network.id; let last = $last) {
        <a
          class="profile__grid__boxes--networks"
          [routerLink]="network?.owner | slug">
          <div [avatar]="{ imgValueUrl: network.image?.url, size: 'small', imgSize: '40px' }"></div>
          <div class="text">
            <p class="semibold">
              {{ network?.name }}
            </p>
            <p
              sharryEllipsisTooltip="2"
              class="small-font">
              {{ network?.description }}
            </p>
          </div>
        </a>
        @if (!last) {
          <div class="divider"></div>
        }
      }
    </div>
  }
</ng-template>

<ng-template
  #proDetails
  let-user="user"
  [typeToken]="typeToken">
  @if (user?.plusAttributes) {
    <div class="info-section">
      @if (user?.plusAttributes) {
        <h4>{{ 'profile.pro-details' | i18next }}</h4>
      }
      @for (plus of user?.plusAttributes; track plus) {
        <p class="info-section__text">
          @if (!!plus?.icon) {
            <sharry-icon
              type="phosphor"
              class="svg-icon"
              name="{{ plus.icon }}"></sharry-icon>
          }
          <span>{{ plus.value }}</span>
        </p>
      }
    </div>
  }
</ng-template>

<ng-template
  #address
  let-user="user"
  [typeToken]="typeToken">
  @if (user?.latitude && user?.longitude && user?.locationAddress) {
    <div class="info-section info-section--links">
      <h4>{{ 'profile.address' | i18next }}</h4>
      <a
        class="directions"
        rel="noopener"
        target="_blank"
        [href]="'https://www.google.com/maps/search/?api=1&query=' + user?.latitude + ',' + user?.longitude">
        <sharry-icon
          name="traffic-sign"
          class="svg-icon"></sharry-icon>
        <span>{{ user?.locationAddress }}</span>
        <br />
        <span class="directions__guide">
          {{ 'profile.section-directions' | i18next }}
          <sharry-icon
            registryName="caret-right"
            class="svg-icon caret"></sharry-icon>
        </span>
      </a>
    </div>
  }
</ng-template>

<ng-template
  #contacts
  let-user="user"
  [typeToken]="typeToken">
  @if (
    user?.contactPhone ||
    user?.contactEmail ||
    user?.websiteUrl ||
    user?.contactWhatsapp ||
    user?.facebookUrl ||
    user?.instagramUrl
  ) {
    <div class="info-section info-section--links">
      <h4>{{ 'profile.contacts' | i18next }}</h4>
      @if (user?.contactPhone) {
        <button
          class="sharry-simple"
          (click)="onTel(user?.contactPhone)">
          <sharry-icon
            name="phone"
            type="phosphor"
            class="svg-icon"></sharry-icon>
          <span>{{ user?.contactPhone }}</span>
        </button>
      }
      @if (user?.contactEmail) {
        <button
          class="sharry-simple"
          (click)="onMailto(user?.contactEmail)">
          <sharry-icon
            name="envelope-simple"
            type="phosphor"
            class="svg-icon"></sharry-icon>
          <span>{{ 'profile.contactEmail' | i18next }}</span>
        </button>
      }
      @if (user?.websiteUrl) {
        <a
          target="_blank"
          [href]="addHttp(removeHttp(user?.websiteUrl))">
          <sharry-icon
            name="link"
            type="phosphor"
            class="svg-icon"></sharry-icon>
          <span>{{ 'profile.websiteUrl' | i18next }}</span>
        </a>
      }
      @if (user?.contactWhatsapp) {
        <a
          target="_blank"
          [href]="'https://api.whatsapp.com/send?phone=' + user?.contactWhatsapp">
          <sharry-icon
            name="whatsapp-logo"
            type="phosphor"
            class="svg-icon"></sharry-icon>
          <span>{{ 'profile.whatsapp' | i18next }}</span>
        </a>
      }
      @if (user?.facebookUrl) {
        <a
          target="_blank"
          [href]="addHttp(removeHttp(user?.facebookUrl))">
          <sharry-icon
            registryName="facebook-logo"
            class="svg-icon"></sharry-icon>
          <span>{{ 'profile.facebook' | i18next }}</span>
        </a>
      }
      @if (user?.instagramUrl) {
        <a
          target="_blank"
          [href]="addHttp(removeHttp(user?.instagramUrl))">
          <sharry-icon
            registryName="instagram-logo"
            class="svg-icon"></sharry-icon>
          <span>{{ 'profile.instagram' | i18next }}</span>
        </a>
      }
    </div>
  }
</ng-template>

<ng-template
  #usefulInformations
  let-user="user"
  [typeToken]="typeToken">
  <div class="info-section info-section--links">
    <h4>{{ 'profile.useful-others' | i18next }}</h4>
    @if (user?.languages?.length) {
      <p class="info-section__text">
        <sharry-icon
          registryName="chat-circle-text"
          class="svg-icon"></sharry-icon>
        <span>
          @for (language of user?.languages; track language.id; let isLast = $last) {
            {{ language.text }}{{ isLast ? '' : ', ' }}
          }
        </span>
      </p>
    }
    @if (user?.attachedDocuments?.length) {
      @for (doc of user?.attachedDocuments; track doc.id) {
        @if (!usingCapacitor) {
          <a
            sharryEllipsisTooltip="1"
            class="cursor-pointer"
            target="_blank"
            [href]="doc.url">
            <sharry-attached-icon [mimeType]="doc.mimeType"></sharry-attached-icon>
            {{ doc.name }}
          </a>
        }
        @if (usingCapacitor) {
          <a
            sharryEllipsisTooltip="1"
            class="cursor-pointer"
            (click)="capacitorDownloadFile(doc.url, doc.name)">
            <sharry-icon
              name="file-arrow-down"
              type="phosphor"
              svgClass="svg-icon"></sharry-icon>
            {{ doc.name }}
          </a>
        }
      }
    }
    <p class="info-section__text">
      <sharry-icon
        registryName="user-circle"
        class="svg-icon"></sharry-icon>
      <span>{{ 'profile.signed-from' | i18next }} {{ user?.createdAt | date: 'LLLL yyyy' }}</span>
    </p>
  </div>
</ng-template>

<sharry-footer class="is-not-mobile"></sharry-footer>
